export const REPORTYEARLYFORECAST_SEARCH = 'REPORTYEARLYFORECAST_SEARCH';
export const REPORTYEARLYFORECAST_PAGE = 'REPORTYEARLYFORECAST_PAGE';
export const REPORTYEARLYFORECAST_YEAR = 'REPORTYEARLYFORECAST_YEAR';
